export default __webpack_public_path__ + "a798ccb3fcbba0f2aab8c1d24de4ffb3.png";